import clsx from "clsx";

import { Button } from "@shared/buttons/button";

import { NumberOfMetrics } from "./tile-modal";

interface Props {
  value: NumberOfMetrics;
  disabled?: boolean;
  onChange(val: NumberOfMetrics): void;
}

export const NumberOfMetricsSwitch = ({ value, disabled, onChange }: Props) => {
  return (
    <div className="flex items-center">
      <Button
        variant={value === NumberOfMetrics.ONE_METRIC ? "primary" : "secondary"}
        disabled={disabled}
        className={clsx(
          "font-normal lowercase rounded-md rounded-r-none",
          "h-8 py-0 flex items-center justify-center",
        )}
        onClick={() => onChange(NumberOfMetrics.ONE_METRIC)}
      >
        1 metric
      </Button>
      <Button
        variant={
          value === NumberOfMetrics.TWO_METRICS ? "primary" : "secondary"
        }
        disabled={disabled}
        className={clsx(
          "font-normal lowercase rounded-md rounded-l-none",
          "h-8 py-0 flex items-center justify-center",
        )}
        onClick={() => onChange(NumberOfMetrics.TWO_METRICS)}
      >
        2 metrics
      </Button>
    </div>
  );
};
